export function FAQSkeleton() {
  return (
    <div className="space-y-3">
      <div className="h-5 w-56 animate-pulse rounded-md bg-muted" />
      <div className="h-14 animate-pulse rounded-xl bg-muted" />
      <div className="h-14 animate-pulse rounded-xl bg-muted" />
      <div className="h-14 animate-pulse rounded-xl bg-muted" />
    </div>
  );
}
